import * as T from './actionTypes';

// Cross-flow list
export const fetchMaterioList = (params) => ({ type: T.FETCH_MATERIO_LIST, payload: params });
export const fetchMaterioListSuccess = (data) => ({ type: T.FETCH_MATERIO_LIST_SUCCESS, payload: data });
export const fetchMaterioListFail = (error) => ({ type: T.FETCH_MATERIO_LIST_FAIL, payload: error });

// DESCENDING
export const fetchDesc = (id) => ({ type: T.FETCH_DESC, payload: id });
export const fetchDescSuccess = (item) => ({ type: T.FETCH_DESC_SUCCESS, payload: item });
export const fetchDescFail = (error) => ({ type: T.FETCH_DESC_FAIL, payload: error });

export const createDesc = (data, callback) => ({ type: T.CREATE_DESC, payload: { data, callback } });
export const createDescSuccess = (item) => ({ type: T.CREATE_DESC_SUCCESS, payload: item });
export const createDescFail = (error) => ({ type: T.CREATE_DESC_FAIL, payload: error });

export const updateDesc = (data, callback) => ({ type: T.UPDATE_DESC, payload: { data, callback } });
export const updateDescSuccess = (item) => ({ type: T.UPDATE_DESC_SUCCESS, payload: item });
export const updateDescFail = (error) => ({ type: T.UPDATE_DESC_FAIL, payload: error });

export const deleteDesc = (id, callback) => ({ type: T.DELETE_DESC, payload: { id, callback } });
export const deleteDescSuccess = (id) => ({ type: T.DELETE_DESC_SUCCESS, payload: id });
export const deleteDescFail = (error) => ({ type: T.DELETE_DESC_FAIL, payload: error });

export const changeStatusDesc = (data, callback) => ({ type: T.CHANGE_STATUS_DESC, payload: { data, callback } });
export const changeStatusDescSuccess = (item) => ({ type: T.CHANGE_STATUS_DESC_SUCCESS, payload: item });
export const changeStatusDescFail = (error) => ({ type: T.CHANGE_STATUS_DESC_FAIL, payload: error });

export const addDescAttachment = (data, callback) => ({ type: T.ADD_DESC_ATTACHMENT, payload: { data, callback } });
export const addDescAttachmentSuccess = (att) => ({ type: T.ADD_DESC_ATTACHMENT_SUCCESS, payload: att });
export const addDescAttachmentFail = (error) => ({ type: T.ADD_DESC_ATTACHMENT_FAIL, payload: error });

export const removeDescAttachment = (attachmentId, parentId, callback) => ({
  type: T.REMOVE_DESC_ATTACHMENT, payload: { attachmentId, parentId, callback },
});
export const removeDescAttachmentSuccess = (attachmentId) => ({ type: T.REMOVE_DESC_ATTACHMENT_SUCCESS, payload: attachmentId });
export const removeDescAttachmentFail = (error) => ({ type: T.REMOVE_DESC_ATTACHMENT_FAIL, payload: error });

// ASCENDING
export const fetchAsc = (id) => ({ type: T.FETCH_ASC, payload: id });
export const fetchAscSuccess = (item) => ({ type: T.FETCH_ASC_SUCCESS, payload: item });
export const fetchAscFail = (error) => ({ type: T.FETCH_ASC_FAIL, payload: error });

export const createAsc = (data, callback) => ({ type: T.CREATE_ASC, payload: { data, callback } });
export const createAscSuccess = (item) => ({ type: T.CREATE_ASC_SUCCESS, payload: item });
export const createAscFail = (error) => ({ type: T.CREATE_ASC_FAIL, payload: error });

export const updateAsc = (data, callback) => ({ type: T.UPDATE_ASC, payload: { data, callback } });
export const updateAscSuccess = (item) => ({ type: T.UPDATE_ASC_SUCCESS, payload: item });
export const updateAscFail = (error) => ({ type: T.UPDATE_ASC_FAIL, payload: error });

export const deleteAsc = (id, callback) => ({ type: T.DELETE_ASC, payload: { id, callback } });
export const deleteAscSuccess = (id) => ({ type: T.DELETE_ASC_SUCCESS, payload: id });
export const deleteAscFail = (error) => ({ type: T.DELETE_ASC_FAIL, payload: error });

export const changeStatusAsc = (data, callback) => ({ type: T.CHANGE_STATUS_ASC, payload: { data, callback } });
export const changeStatusAscSuccess = (item) => ({ type: T.CHANGE_STATUS_ASC_SUCCESS, payload: item });
export const changeStatusAscFail = (error) => ({ type: T.CHANGE_STATUS_ASC_FAIL, payload: error });

// Activity (shared)
export const fetchMaterioActivity = (flowKind, id) => ({ type: T.FETCH_MATERIO_ACTIVITY, payload: { flowKind, id } });
export const fetchMaterioActivitySuccess = (entries) => ({ type: T.FETCH_MATERIO_ACTIVITY_SUCCESS, payload: entries });
export const fetchMaterioActivityFail = (error) => ({ type: T.FETCH_MATERIO_ACTIVITY_FAIL, payload: error });

export const clearMaterioMessages = () => ({ type: T.CLEAR_MATERIO_MESSAGES });
